import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { BaseListComponent } from 'src/app/base/components/base-list.component';
import { ProjetoCompletoConstant } from '../constants/projeto-completo.constant';
import { ImportarIrcpModalComponent } from '../importar-ircp-modal/importar-ircp-modal.component';
import { ImportarIrcp } from '../models/importar-ircp.model';
import { NavigationService } from '../services/navigation.service';

@Component({
  selector: 'app-importar-ircp',
  templateUrl: './importar-ircp.component.html',
  styleUrls: ['./importar-ircp.component.scss']
})
export class ImportarIrcpComponent extends BaseListComponent<ImportarIrcp> implements OnInit, OnDestroy {

  importarIrcp: ImportarIrcp[] = ProjetoCompletoConstant.IMPORTAR_IRCP;

  constructor(
    private navigation: NavigationService
  ) {
    super();
  }

  @ViewChild('modal') modal: ImportarIrcpModalComponent;

  ngOnInit() {
    this.loaded();
  }

  ngOnDestroy(): void {
    this.unsubscribeList();
  }

  openModal(data) {
    this.modal.openModal(data);
  }
}
